import m, {Vnode, VnodeDOM} from "mithril";
import {TInterviewThreadCompletionModalViewModel} from "../model/TInterviewThreadViewModel";

type TCompletionModalAttrs = {
    model: TInterviewThreadCompletionModalViewModel|null,
    onAction: () => void,
};

export default class CompletionModalView {

    private element: HTMLDivElement|null = null;
    private dismissed = false;
    private readonly hiddenHandler = (): void => {
        this.dismissed = true;
        m.redraw();
    };

    public oncreate(vnode: VnodeDOM<TCompletionModalAttrs>): void {
        this.element = vnode.dom as HTMLDivElement;
        $(this.element).on("hidden.bs.modal", this.hiddenHandler);
        this.show();
    }

    public onupdate(): void {
        this.show();
    }

    public onremove(): void {
        if (this.element === null) {
            return;
        }
        const $modal = $(this.element);
        $modal.off("hidden.bs.modal", this.hiddenHandler);
        if ($modal.hasClass("show")) {
            $modal.modal("hide");
        }
        this.element = null;
    }

    public view(vnode: Vnode<TCompletionModalAttrs>): Vnode|null {
        const model = vnode.attrs.model;
        if (this.dismissed || !model?.visible) {
            return null;
        }

        return m(".modal.fade.interview-thread-completion-modal", {
            tabindex: -1,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": model.titleId,
            "aria-describedby": model.bodyId,
        }, [
            m(".modal-dialog.interview-thread-completion-dialog", [
                m(".modal-content", [
                    m(".modal-body.pt-4.pb-0", [
                        m("img.d-block.mx-auto.mb-4.interview-thread-completion-image", {
                            src: model.imageUrl,
                            alt: "",
                        }),
                        m(`h1#${model.titleId}.interview-thread-completion-title.text-center`, model.title),
                    ]),
                    m(".modal-body.pt-3", [
                        // The HTML comes exclusively from server-controlled translation files.
                        m(`p#${model.bodyId}.interview-thread-completion-text.text-center`, {
                            className: model.duration ? "mb-3" : "mb-0",
                        }, m.trust(model.bodyHtml)),
                        model.duration
                            ? m(".interview-thread-completion-duration.text-center.mb-0", [
                                m("span.text-secondary", `${model.durationLabel}: `),
                                m("strong", model.duration),
                            ])
                            : null,
                    ]),
                    m(".modal-footer.justify-content-center.pt-0.pb-4.border-0", [
                        m("button.btn.btn-success", {
                            type: "button",
                            onclick: vnode.attrs.onAction,
                        }, model.buttonLabel),
                    ]),
                ]),
            ]),
        ]);
    }

    private show(): void {
        if (this.dismissed || this.element === null) {
            return;
        }
        const $modal = $(this.element);
        if ($modal.hasClass("show")) {
            return;
        }
        $modal.modal({
            backdrop: true,
            keyboard: true,
            focus: true,
        });
        $modal.modal("show");
    }

}
